// Rank and size the usage chart by calls so free APIs remain visible.
export const topApisByCalls = (rows, limit = 6) => {
  const shown = [...rows]
    .sort((a, b) => (Number(b.calls) || 0) - (Number(a.calls) || 0))
    .slice(0, limit);
  const max = Math.max(...shown.map((row) => Number(row.calls) || 0), 1);
  return shown.map((row) => ({
    ...row,
    usagePercent: ((Number(row.calls) || 0) / max) * 100,
  }));
};

// Network failures use 0; only absent status fields use the legacy default.
export const usageStatus = (record) => record.status ?? record.statusCode ?? 200;
